import { useMutation, useQueryClient } from '@tanstack/react-query';
import { queryKeys, accountsService } from '@v2/services';

export const useRemoveAccountFromPartner = () => {
  const queryClient = useQueryClient();

  const mutation = useMutation({
    mutationFn: ({ partnerId, accountId }: { partnerId: string; accountId: string }) =>
      accountsService.removeAccountFromPartner(partnerId, accountId),
    onSuccess: () => {
      queryClient.invalidateQueries(queryKeys.accounts.all);
      queryClient.invalidateQueries(queryKeys.partners.all);
    },
  });

  const removeAccountFromPartner = async (
    partnerId: string,
    accountId: string
  ): Promise<boolean> => {
    try {
      await mutation.mutateAsync({ partnerId, accountId });
      return true;
    } catch {
      return false;
    }
  };

  return {
    removeAccountFromPartner,
    loading: mutation.isLoading,
    error: mutation.error instanceof Error ? mutation.error.message : null,
  };
};

export default useRemoveAccountFromPartner;
